import ArticleContact from './ArticleContact.react';
var ArticleContacts = function ArticleContacts(_ref) {
  var contacts = _ref.contacts;
  return /*#__PURE__*/React.createElement("div", {
    className: "a-contacts"
  }, /*#__PURE__*/React.createElement("ul", null, contacts.sort(function (a, b) {
    return a.slot - b.slot;
  }).map(function (x) {
    return /*#__PURE__*/React.createElement(ArticleContact, {
      contactID: x.contactID,
      key: x._id
    });
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      clear: 'both'
    }
  }));
};
export default ArticleContacts;